import { InputAdornment } from '@mui/material';
import type { InputAdornmentProps, Theme } from '@mui/material';
import { styled } from '@mui/material/styles';

const BorderedInputAdornment = styled(InputAdornment)<InputAdornmentProps>(({ theme }: { theme: Theme }) => ({
  '&.MuiInputAdornment-root.MuiInputAdornment-positionStart': {
    borderRight: '1px solid',
    borderRightColor: theme.palette.divider,
    height: '100%',
    '& > p': {
      paddingRight: 8,
    },
  },
  '&.MuiInputAdornment-root.MuiInputAdornment-positionEnd': {
    borderLeft: '1px solid',
    borderLeftColor: theme.palette.divider,
    height: '100%',
    '& > p': {
      paddingLeft: 8,
    },
  },
})) as unknown as typeof InputAdornment;

export default BorderedInputAdornment;
